import Loadable from "react-loadable";

const LazyPropale = Loadable({
  loader: () => import(/* webpackChunkName: 'propale' */ "./index"),
  loading: () => 'loading...'
});

export default LazyPropale;
